import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export const Skeleton = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(function Skeleton(
  { className, ...props },
  ref
) {
  return (
    <div
      ref={ref}
      aria-busy="true"
      className={cn("animate-pulse rounded bg-zinc-200", className)}
      {...props}
    />
  );
});
